import { render } from "./PageHeader1.vue?vue&type=template&id=a042ba1e&scoped=true"
import script from "./PageHeader1.vue?vue&type=script&lang=js"
export * from "./PageHeader1.vue?vue&type=script&lang=js"

import "./PageHeader1.vue?vue&type=style&index=0&id=a042ba1e&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/texnoelm/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a042ba1e"]])

export default __exports__